import React from 'react';
import ContentCard from '@hpstellar/core/visId/ContentCard'

import useSearchPagination from '../useSearchPagination';
import { formatMetricValue } from '../../metrics/metrics-helpers';
import useHawksearchComponent from '../useHawksearchComponent';
import { getSrpLinkData } from '../util';

import './css/search-page-contents.less';


const parseSearchData = (data) => {
    try{
        return JSON.parse(data.raw);
    }catch(e){}

    return data;
}

const SearchPageContents = ({ gtmConfig, pStoreID }) => {

    const hawksearchResults = useHawksearchComponent();
    const hawksearchSearchData = hawksearchResults && hawksearchResults.content;
    let {
        Results,
        Pagination,
    } = hawksearchSearchData || {};

    let {
        CurrentPage
    } = Pagination || {};
    let paginatedSearchResults = useSearchPagination(Results, CurrentPage);
    const hasResults = paginatedSearchResults && paginatedSearchResults.length > 0;
    return (
        <div className="search-content-container">
            <div className='search-content-tiles-container search-tiles-container'>
                {
                    hasResults && paginatedSearchResults.map(
                        (blog, idx) => {
                            let { Document } = blog || {};
                            let { pdp_url, thumbnailimage, html_content, description, product_name} = Document || {};
                            const marketingLink = pdp_url && pdp_url[0];
                            let imageProps = {
                                src: thumbnailimage && thumbnailimage[0]
                            };
                            const { target, to } = getSrpLinkData(marketingLink, pStoreID, 'content') || {}
                            const tileProps = {
                                imageProps,
                                buttons: [{
                                    children: 'Learn',
                                    variation: 'primary',
                                    theme: 'dark',
                                    to,
                                    ...target ? { target } : {}
                                }],
                                titleTypographyProps: {
                                    style: {
                                        fontWeight: 400,
                                        flexGrow: 1 // paragraph is 66px, the remaining space is taken by title, so that the line is always aligned.
                                    }
                                },
                                title: product_name && product_name[0],
                                description: (description && description[0]) || ' ', // TODO: Space adds GFE divider when there isn't a description
                                descriptionTypographyProps: {
                                    style: {
                                        margin: 0,
                                        height: 66
                                    }
                                },
                                className: 'srp-content-tile-container'
                            }

                            let tileGtmId = gtmConfig && gtmConfig.linkClick && gtmConfig.linkClick.gtmId;
                            let gtmProps = tileGtmId
                                ? {
                                      'data-gtm-category': 'linkClick',
                                      'data-gtm-value': formatMetricValue(tileProps.title),
                                      'data-gtm-id': tileGtmId,
                                  }
                                : {};
                        
                            return (
                                <div className='search-content-tile' key={idx} {...gtmProps}>
                                    <ContentCard {...tileProps} />
                                </div>
                            )
                        }
                    )
                }
            </div>
        </div>
    )
};

export default SearchPageContents;